import { types, applySnapshot } from 'mobx-state-tree';

const Admin = types
    .model('Admin', {
        id: types.identifierNumber,
        first_name: types.maybeNull(types.string),
        last_name: types.maybeNull(types.string),
        email: types.optional(types.string, ''),
        username: types.maybeNull(types.string),
        phone: types.maybeNull(types.string),
        roles: types.array(types.string),
        deleted_at: types.maybeNull(types.string),
        password: types.maybe(types.string),
    })
    .actions((self) => ({
        editAdmin(edited) {
            applySnapshot(self, { ...self, ...edited });
        },
    }));

export default Admin;
